module.exports = __webpack_public_path__ + "static/img/bg-pt.13802b9b.png";